import PropTypes from 'prop-types';
import { useMemo, useState } from 'preact/hooks';
import { useLocation } from 'react-router';

const links = [
  {
    title: 'U.S. Privacy Notice',
    href: 'https://www.stjude.org/legal/u-s-privacy-policy-statement.html',
  },
  {
    title: 'Disclaimer / Registrations / Copyright Statement',
    href: 'https://www.stjude.org/legal.html',
  },
  {
    title: 'Linking Policy',
    href: 'https://www.stjude.org/legal/linking-policy.html',
  },
  {
    title: 'Notice of Privacy Practices (HIPAA)',
    href: 'https://www.stjude.org/legal/notice-of-privacy-practices.html',
  },
  {
    title: 'Ad Choices',
    href: 'https://www.stjude.org/legal/u-s-privacy-policy-statement.html#advertising',
  },
  {
    title: 'Notice of Non-Discrimination',
    href: 'https://www.stjude.org/legal/notice-of-non-discrimination.html',
  },
  {
    title: 'Site Map',
    href: 'https://www.stjude.org/sitemap.html',
  },
  {
    title: 'Your Opt-Out Rights',
    href: 'https://www.stjude.org/legal/your-opt-out-rights.html',
  },
  {
    title: 'Washington Health Privacy Notice',
    href: 'https://www.stjude.org/legal/u-s-privacy-policy-statement/washington-health-privacy-notice.html',
  },
];

Footer.propTypes = {
  constrictWidth: PropTypes.bool,
};
export default function Footer({ constrictWidth = false }) {
  const location = useLocation();
  const [currentPath, setCurrentPath] = useState('');
  const showDisclaimer = useMemo(() => {
    return ['/overlays/alerts', '/overlays/gifts-that-give'].includes(
      currentPath
    );
  }, [currentPath]);

  setCurrentPath(location.pathname);

  return (
    <>
      <div className="bg-base-200 text-base-content flex items-center w-full justify-center">
        <footer
          className={`footer footer-center bg-base-200 text-base-content rounded p-10  ${constrictWidth ? 'max-w-screen-2xl' : 'max-w-full'}`}
        >
          <nav className="grid xl:grid-flow-col gap-6">
            {links.map((link) => {
              return (
                <a
                  key={link.href}
                  href={link.href}
                  rel="noopener noreferrer"
                  target="_blank"
                  className="link link-hover text-xs"
                >
                  {link.title}
                </a>
              );
            })}
          </nav>
          {showDisclaimer && (
            <p className="max-w-screen-lg text-xs mb-4 mt-2">
              Disclaimer: When you make a donation using any of these tools,
              your donation will be used to support breakthrough research,
              treatment and cures. Items listed in this section are
              representative of services and supplies that are part of the
              treatment and care of children of St. Jude. The cost of each item
              or service is an approximation and will vary based on actual costs
              incurred and individual patient needs. Your donations will be used
              to support the general operating expenses of St. Jude. Thanks to
              generous supporters, families never receive a bill from St. Jude
              for treatment, travel, housing or food — because all a family
              should worry about is helping their child live.
            </p>
          )}
          <aside>
            <p>
              Copyright © {new Date().getFullYear()} St. Jude Children&apos;s
              Research Hospital, a not-for-profit, section 501(c)(3).
            </p>
          </aside>
        </footer>
      </div>
    </>
  );
}
